export const enum QualityAuditWorkflowConfigPreset {
  CAMP_WORKFLOW = 'CAMP_WORKFLOW',
  BATCH_ONLY_ALLOWS_REJECTIONS = 'BATCH_ALLOWS_ONLY_REJECTIONS',
  BATCH_ONLY_ALLOWS_APPROVALS = 'BATCH_ONLY_ALLOWS_APPROVALS',
}

export const presetDetails: {
  [preset: string]: {
    shortDescription?: string
  }
} = {
  [QualityAuditWorkflowConfigPreset.CAMP_WORKFLOW]: {
    shortDescription: 'Enable Camp to publish to QAS.',
  },
  [QualityAuditWorkflowConfigPreset.BATCH_ONLY_ALLOWS_APPROVALS]: {
    shortDescription: 'Configures the batch to only allow auditors to accept tasks',
  },
  [QualityAuditWorkflowConfigPreset.BATCH_ONLY_ALLOWS_REJECTIONS]: {
    shortDescription: 'Configures the batch to only allow auditors to reject tasks',
  },
}
